import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { volumes } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-109" data-mp="258c2htzm5qsg">
      <div className="mx-auto max-w-2xl" data-id="element-110" data-mp="1r9m8woc0698u">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-111" data-mp="1r8t8e53n0fz5">
          <span aria-hidden="true" data-id="element-112" data-mp="1vciv0p0r4nhj">📚 </span>The Six Volumes
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-113" data-mp="1hhyk6v6tz6b2">
          {volumes.map(volume => <li key={volume.number} className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 text-sm font-medium text-stone-800" data-id="element-114" data-mp="1ma9i5si0gi0z">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-115" data-mp="17mwuny8n827y" />
              <span className="font-extrabold tabular-nums text-red-500" data-id="element-116" data-mp="1ckg9p0d60j0y">
                {volume.number}
              </span>
              {volume.title}
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-bold italic text-red-500 sm:text-xl" data-id="element-117" data-mp="13i72ajd715rs">
          One lesson a week. A full 36-week teaching year—from the first
          welcome to the final farewell.
        </p>
      </div>
    </section>;
}